import {ProductImageTypes} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_images.types';
import {ImagesSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useRouteEntities} from '@aboutyou/router';
import {isProductTileEntities} from '../../../features/ProductTile/isProductTileEntities';
import {ProductTileEntities} from '../../../features/ProductTile/types';

export const useComputeDefaultState = ():
  | (ImagesSection & {gridColumns?: number})
  | undefined => {
  const entities =
    useRouteEntities<ProductTileEntities>() as ProductTileEntities;

  if (!isProductTileEntities(entities)) {
    return undefined;
  }

  const {
    primaryBustImageGallery,
    primaryModelImageGallery,
    preferredProductImageType,
    brand,
    product,
    gallery,
    gridColumns,
  } = entities;

  const imageGallery =
    preferredProductImageType === ProductImageTypes.MODEL
      ? primaryModelImageGallery
      : primaryBustImageGallery;

  return {
    gallery: gallery?.elements?.length
      ? gallery
      : {
          elements: imageGallery.map(image => ({
            type: {
              $case: 'image',
              image: {
                image,
              },
            },
          })),
          initialElementIndex: 0,
        },
    images: imageGallery.map(image => ({image})),
    brand,
    product,
    badges: [],
    qualitativeBadges: [],
    gridColumns,
  };
};
